import {
    Component, OnInit
} from '@angular/core';
import IDropdown from '@crediblefinance/credible-ui/lib/interfaces/IDropdown';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { HttpService } from '../../services/http.service';
import { OnboardingService } from '../onboarding.service';

@Component({
    selector: 'app-airdrop-leaderboard',
    templateUrl: './airdrop-leaderboard.component.html',
    styleUrl: './airdrop-leaderboard.component.scss'
})
export class AirdropLeaderboardComponent implements OnInit {
    levelOptions: Array<IDropdown> = [];
    current_level = '1';
    current_level_name: any;
    topPerformers: Array<any> = [];
    loading_tvl_stats = true;
    loading: boolean = false;
    total_count: number = 0;
    page: number = 0;
    limit: number = 10;

    topCredUsers: Array<any> = [];
    loading_cred_stats = true;

    constructor(
        public httpService: HttpService,
        private onboardingService: OnboardingService,
        private cfAlertService: CfAlertService
    ) { }

    ngOnInit(): void {
        this.getTopMoonsHolders();
    }

    getTopMoonsHolders() {
        this.loading = true;

        this.onboardingService.getTopMoonsHolders(this.page, this.limit).subscribe((res) => {
            this.topPerformers = res.data;
            this.total_count = res.total_count;

            this.loading = false;
        }, (err: HttpErrorResponse) => {
            console.error(err);

            this.loading_tvl_stats = false;

            this.cfAlertService.showError(err);
        });
    }

    pageChanged(event: any) {
        this.page = event;
        this.getTopMoonsHolders();
    }

    getRankSuffix(rank: number) {
        const last_digit = rank % 10;

        let rank_suffix = '';

        if (rank > 10 && (rank % 100) >= 11 && (rank % 100) <= 13)
            rank_suffix = 'th';

        else if (last_digit === 1)
            rank_suffix = 'st';

        else if (last_digit === 2)
            rank_suffix = 'nd';

        else if (last_digit === 3)
            rank_suffix = 'rd';
        
        else
            rank_suffix = 'th';

        return rank_suffix;
    }
}
